import { Fragment } from 'react';
import { Stack } from '@mui/material';

import Form from 'components/Form';
import { IFormRegister, IFormValues } from 'routes/Main/type';

import RowContainer from '../../components/RowContainer';
import RowContent from './components/RowContentSub';
import SectionTitle from '../../components/SectionTitle';
import CheckboxOne from './components/CheckboxOne';

interface Props extends IFormRegister, IFormValues {
  disabled?: boolean;
}

const Extroversion = (props: Props) => {
  const { disabled, register, getValues, setValue } = props;

  return (
    <Fragment>
      <SectionTitle title="일반적인 외모, 태도, 행동" />

      <RowContainer xs={12}>
        <RowContent title="일반적인 외모" titleRatio={1.2} childrenRatio={10.8}>
          <Stack direction="row" spacing={1}>
            <Form.MuiTextField
              required={false}
              fullWidth
              disabled={disabled}
              placeholder="직접 입력"
              {...register('extroversion.input')}
            />
          </Stack>
        </RowContent>
        <RowContent title="태도" titleRatio={1.35} childrenRatio={10.5}>
          <CheckboxOne
            i18nNullKey="ETC"
            disabled={disabled}
            i18nKey="MSE.ATTITUDE"
            values={[1, 2, 3, 4, 5]}
            defaultValue={getValues('extroversion.attitude.checked')}
            onChange={v => {
              setValue('extroversion.attitude.checked', v);
            }}
          />
        </RowContent>
        <RowContent title="" titleRatio={1.2} childrenRatio={10.8}>
          <CheckboxOne
            i18nNullKey="ETC"
            disabled={disabled}
            i18nKey="MSE.ATTITUDE"
            values={[6, 7, 8, 9, 10]}
            defaultValue={getValues('extroversion.attitude_two.checked')}
            onChange={v => {
              setValue('extroversion.attitude_two.checked', v);
            }}
          />
        </RowContent>
        <RowContent title="행동" titleRatio={1.35} childrenRatio={10.5}>
          <CheckboxOne
            i18nNullKey="ETC"
            disabled={disabled}
            i18nKey="MSE.ACTION"
            values={[1, 2, 3, 4, 5]}
            defaultValue={getValues('extroversion.action.checked')}
            onChange={v => {
              setValue('extroversion.action.checked', v);
            }}
          />
        </RowContent>
        <RowContent title="" titleRatio={1.2} childrenRatio={10.8}>
          <CheckboxOne
            i18nNullKey="ETC"
            disabled={disabled}
            i18nKey="MSE.ACTION"
            values={[6, 7, 8, 9, 10]}
            defaultValue={getValues('extroversion.action_two.checked')}
            onChange={v => {
              setValue('extroversion.action_two.checked', v);
            }}
          />
        </RowContent>
        <RowContent title="" titleRatio={1.2} childrenRatio={10.8}>
          <CheckboxOne
            i18nNullKey="ETC"
            disabled={disabled}
            i18nKey="MSE.ACTION"
            values={[11, 12, 13, 14]}
            defaultValue={getValues('extroversion.action_three.checked')}
            onChange={v => {
              setValue('extroversion.action_three.checked', v);
            }}
          />
        </RowContent>
      </RowContainer>
    </Fragment>
  );
};

export default Extroversion;
